import { render } from "./NPSForm.vue?vue&type=template&id=0a0d3413&scoped=true"
import script from "./NPSForm.vue?vue&type=script&lang=js"
export * from "./NPSForm.vue?vue&type=script&lang=js"

import "./NPSForm.vue?vue&type=style&index=0&id=0a0d3413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0d3413"]])

export default __exports__